var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ob1-popin-modal2",
    {
      attrs: {
        id: _vm.modalId,
        "aria-labelledby": _vm.modalLabelId,
        "show-close-button": false,
      },
    },
    [
      _c("div", {
        staticClass: "h4",
        attrs: { id: _vm.modalLabelId },
        domProps: { innerHTML: _vm._s(_vm.messages.title) },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "m-auto mt-1 mb-2", attrs: { id: "result" } },
        [
          _c(
            "div",
            { staticClass: "bg-gray2 p-1 px-2 mb-1", attrs: { id: "total" } },
            [
              _c("span", { staticClass: "big" }, [
                _vm._v(_vm._s(_vm.totalFormatted)),
              ]),
              _vm._v(" "),
              _c("small", { staticClass: "text-start ps-1" }, [
                _vm._v("pour la reprise de votre"),
                _c("br"),
                _c("strong", {
                  domProps: { innerHTML: _vm._s(_vm.estimatedDeviceModel) },
                }),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm.bonus && _vm.bonus.amountInCents > 0
            ? _c("div", { attrs: { id: "with-bonus" } }, [
                _c("div", { staticClass: "result-detail bg-gray2 p-1" }, [
                  _c("div", { staticClass: "big" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.recoveryFormatted) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("small", [_vm._v("pour votre appareil")]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "result-plus p-1 big" }, [
                  _vm._v("\n                +\n            "),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "result-detail bg-gray2 p-1" }, [
                  _c("div", { staticClass: "big" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.bonusFormatted) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("small", [_vm._v("de bonus reprise")]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("AlertMessage", {
            staticClass: "mt-1 text-start",
            attrs: {
              type: "warning",
              "is-mini": "",
              title: _vm.messages.warningMessage,
              "bold-title": false,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("hr", {
        staticClass: "separator separator--gray4 mb-1",
        attrs: { "aria-hidden": "true" },
      }),
      _vm._v(" "),
      _c("p", [
        _c("strong", {
          domProps: { innerHTML: _vm._s(_vm.labels.subtitle.text) },
        }),
      ]),
      _vm._v(" "),
      _vm.labels.subtitle.link
        ? _c(
            "div",
            [
              _c("Lien", {
                attrs: {
                  "is-link-arrow": "",
                  "open-new-tab": "",
                  href: _vm.labels.subtitle.link.url,
                  label: _vm.labels.subtitle.link.label,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("ul", { staticClass: "list-unstyled mt-1" }, [
        _c("li", { staticClass: "text-mw mb-1" }, [
          _c("div", { staticClass: "items-list-item highlight" }, [
            _c("span", {
              staticClass: "item-icon",
              class: _vm.labels.firstItem.icon,
              attrs: { "aria-hidden": "true" },
            }),
            _vm._v(" "),
            _c("p", {
              staticClass: "mb-0",
              domProps: { innerHTML: _vm._s(_vm.labels.firstItem.text) },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "text-mw mb-1" }, [
          _c("div", { staticClass: "items-list-item highlight" }, [
            _c("span", {
              staticClass: "item-icon",
              class: _vm.labels.secondItem.icon,
              attrs: { "aria-hidden": "true" },
            }),
            _vm._v(" "),
            _c("p", {
              staticClass: "mb-0",
              domProps: { innerHTML: _vm._s(_vm.labels.secondItem.text) },
            }),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.labels.bonASavoir
        ? _c("AlertMessage", {
            attrs: {
              title: _vm.labels.bonASavoir.text,
              "no-background": true,
              "bold-title": false,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showDipliConsent
        ? _c("CheckBox", {
            staticClass: "pb-1",
            attrs: {
              id: _vm.modalId + "-dipli-consent",
              "model-value": _vm.isDipliConsentChecked,
              label: _vm.labels.dipliConsent.text,
            },
            on: { change: _vm.onCheckboxChange },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { attrs: { id: "sticky-container" } }, [
        _c("div", { staticClass: "bg-white pb-1" }, [
          _c("hr", {
            staticClass: "separator separator--gray4 mb-1 d-md-none m-auto",
            attrs: { "aria-hidden": "true" },
          }),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { id: "buttons-container" } },
            [
              _c("Lien", {
                attrs: {
                  id: "other-simulation-button",
                  "is-link-arrow-back": "",
                  "is-mini": "",
                  "is-button": "",
                  label: _vm.messages.otherSimulationButtonLabel,
                },
                on: {
                  click: function ($event) {
                    return _vm.newSimulation()
                  },
                },
              }),
              _vm._v(" "),
              _c("button", {
                staticClass: "d-block btn btn-primary",
                attrs: { id: "continue-button", type: "button", href: "#" },
                domProps: { innerHTML: _vm._s(_vm.messages.buttonLabel) },
                on: {
                  click: function ($event) {
                    return _vm.saveAndClose()
                  },
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }